const VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
const MATCH_URL_VKVIDEO = /(?:vk\.com|(?:[\w]+\.)?vkvideo\.ru|m\.vk\.com)(?:\/video)?(?:\?z=video)?(?:\?oid=)?(-?\d+)[_&](\d+)/;
const MATCH_URL_RUTUBE = /https?:\/\/(?:www\.|sport\.|news\.|kids\.)?rutube\.(?:ru|com|sport)\/video\/([^\/\?]+)\/?/;
const canPlayFile = (url, test)=>{
    if (Array.isArray(url)) {
        for (const item of url){
            if ('string' == typeof item && canPlayFile(item, test)) return true;
            if (canPlayFile(item.src, test)) return true;
        }
        return false;
    }
    return test(url);
};
const canPlay = {
    html: (url)=>canPlayFile(url, (u)=>VIDEO_EXTENSIONS.test(u)),
    vkvideo: (url)=>MATCH_URL_VKVIDEO.test(url),
    rutube: (url)=>MATCH_URL_RUTUBE.test(url)
};
export { MATCH_URL_RUTUBE, MATCH_URL_VKVIDEO, VIDEO_EXTENSIONS, canPlay };
